module.exports = __webpack_public_path__ + "static/img/cajamitrasback.749f08c6.svg";